import { HTMLAttributes } from 'react'

import SVGIcon from '@/components/base/SVGIcon'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type SocialMenuProps = HTMLAttributes<HTMLElement> & {
  revealDelay?: number
}

const SocialMenu = ({ className, revealDelay = 0, ...props }: SocialMenuProps) => {
  const { menu } = useStore()

  return (
    <ul className={cn('flex items-center space-x-spacing-xxs', className)} {...props}>
      {menu?.social_menu.menu.map(({ url, target, title, classes }, index) => (
        <li key={index} className="flex" data-motion-social>
          <a
            href={url}
            target={target}
            className={cn([
              '-m-spacing-xxs flex overflow-hidden p-spacing-xxs',
              'pointer:hover:opacity-50',
              'transition-opacity duration-300 ease-out-cubic'
            ])}
          >
            <span
              className="icon inline-flex"
              style={
                revealDelay > 0
                  ? {
                      transitionDelay: `${300 + 30 * (revealDelay + index)}ms`
                    }
                  : undefined
              }
            >
              <span className="sr-only">{title}</span>
              <SVGIcon
                symbol={`${classes}-icon`}
                className="h-[1.6rem] w-[1.6rem] fill-text-primary-dark"
              />
            </span>
          </a>
        </li>
      ))}
    </ul>
  )
}

export default SocialMenu
